function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__a",
  x1: -184.05,
  y1: -226.64,
  x2: 273.1,
  y2: -226.64,
  gradientTransform: "translate(0 694)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__c",
  x1: -185.88,
  y1: -226.83,
  x2: 263.5,
  y2: -226.83,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__d",
  x1: -187.71,
  y1: -227.03,
  x2: 254,
  y2: -227.03,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__e",
  x1: -189.54,
  y1: -227.18,
  x2: 244.5,
  y2: -227.18,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__f",
  x1: -191.36,
  y1: -227.33,
  x2: 234.9,
  y2: -227.33,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__g",
  x1: -193.18,
  y1: -227.53,
  x2: 225.4,
  y2: -227.53,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__h",
  x1: -195,
  y1: -227.67,
  x2: 215.8,
  y2: -227.67,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__i",
  x1: -196.83,
  y1: -227.82,
  x2: 206.3,
  y2: -227.82,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__j",
  x1: -198.71,
  y1: -227.92,
  x2: 196.8,
  y2: -227.92,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__k",
  x1: -200.53,
  y1: -228.12,
  x2: 187.2,
  y2: -228.12,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__l",
  x1: -202.36,
  y1: -228.32,
  x2: 177.7,
  y2: -228.32,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__m",
  x1: -204.18,
  y1: -228.47,
  x2: 168.2,
  y2: -228.47,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__n",
  x1: -206.04,
  y1: -228.61,
  x2: 158.6,
  y2: -228.61,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__o",
  x1: -207.87,
  y1: -228.76,
  x2: 149.1,
  y2: -228.76,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__p",
  x1: -209.7,
  y1: -228.96,
  x2: 139.5,
  y2: -228.96,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__q",
  x1: -211.53,
  y1: -229.11,
  x2: 130,
  y2: -229.11,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__r",
  x1: -213.36,
  y1: -229.21,
  x2: 120.4,
  y2: -229.21,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__s",
  x1: -215.25,
  y1: -229.4,
  x2: 110.9,
  y2: -229.4,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__t",
  x1: -217.09,
  y1: -229.6,
  x2: 101.4,
  y2: -229.6,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__u",
  x1: -218.96,
  y1: -229.75,
  x2: 91.8,
  y2: -229.75,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__v",
  x1: -220.77,
  y1: -229.9,
  x2: 82.3,
  y2: -229.9,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__w",
  x1: -222.64,
  y1: -230.05,
  x2: 72.8,
  y2: -230.05,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__x",
  x1: -224.48,
  y1: -230.14,
  x2: 63.3,
  y2: -230.14,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__y",
  x1: -226.33,
  y1: -230.39,
  x2: 53.7,
  y2: -230.39,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__z",
  x1: -228.19,
  y1: -230.54,
  x2: 44.2,
  y2: -230.54,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__A",
  x1: -230.04,
  y1: -230.69,
  x2: 34.6,
  y2: -230.69,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__B",
  x1: -231.97,
  y1: -230.83,
  x2: 25.1,
  y2: -230.83,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__C",
  x1: -233.84,
  y1: -231.03,
  x2: 15.5,
  y2: -231.03,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-left_svg__D",
  x1: -235.74,
  y1: -231.18,
  x2: 6,
  y2: -231.18,
  xlinkHref: "#bg-splash-left_svg__a"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "bg-splash-left_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-3.1-.2h323.2V813H-3.1z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg-splash-left_svg__b)",
  strokeMiterlimit: 10,
  strokeWidth: 0.8,
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-159.6 62.3C-283.4 325.4 113.2 259.2 71.3 530.8 32.5 782.5 272.7 762.5 272.7 872.6",
  stroke: "url(#bg-splash-left_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-162 61.9C-282.8 325 103.7 263.8 65.4 530.5 29.3 776.7 263.1 760.4 263.1 872.6",
  stroke: "url(#bg-splash-left_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-164.4 61.6c-117.9 263 259.3 206.9 223.8 468.6C26.9 771 253.6 758.4 253.6 872.5",
  stroke: "url(#bg-splash-left_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-166.8 61.3C-281.7 324.3 85.7 273.2 53.5 530 24.1 765.3 244.1 756.3 244.1 872.5",
  stroke: "url(#bg-splash-left_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-169.2 61C-281.1 323.9 76.5 277.8 47.6 529.7 21.2 759.5 234.5 754.3 234.5 872.5",
  stroke: "url(#bg-splash-left_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-171.6 60.6c-108.9 263 238.9 221.8 213.3 468.8C18.4 753.7 225 752.2 225 872.5",
  stroke: "url(#bg-splash-left_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-174 60.3C-279.9 323.2 58.1 287 35.7 529.1c-20.2 218.8 179.7 221 179.7 343.4",
  stroke: "url(#bg-splash-left_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-176.4 60C-279.3 322.9 48.8 291.5 29.8 528.8 12.7 742.2 205.9 748.1 205.9 872.5",
  stroke: "url(#bg-splash-left_svg__i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-178.9 59.7C-278.7 322.5 39.6 296.1 23.9 528.6c-14.1 207.8 172.5 217.5 172.5 344",
  stroke: "url(#bg-splash-left_svg__j)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-181.3 59.4C-278.1 322.2 30.4 300.7 17.9 528.3 6.9 730.6 186.8 744 186.8 872.5",
  stroke: "url(#bg-splash-left_svg__k)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-183.7 59C-277.5 321.8 21.1 305.2 12 528 4 724.7 177.3 742 177.3 872.5",
  stroke: "url(#bg-splash-left_svg__l)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-186.1 58.7c-90.8 262.8 197.9 251.1 192.2 469-5 191.2 161.7 212.2 161.7 344.8",
  stroke: "url(#bg-splash-left_svg__m)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-188.5 58.4C-276.4 321.1 2.5 314.3.2 527.5c-2.1 185.6 158 210.4 158 345",
  stroke: "url(#bg-splash-left_svg__n)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-190.9 58.1C-275.8 320.8-6.8 318.8-5.8 527.2c1 180.1 154.5 208.6 154.5 345.3",
  stroke: "url(#bg-splash-left_svg__o)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-193.3 57.7C-275.2 320.4-16.2 323.3-11.7 526.9c3.9 174.5 150.8 206.9 150.8 345.6",
  stroke: "url(#bg-splash-left_svg__p)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-195.7 57.4C-274.6 320-25.6 327.8-17.6 526.6c6.7 168.9 147.2 205.1 147.2 345.9",
  stroke: "url(#bg-splash-left_svg__q)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-198.1 57.1C-274 319.7-35 332.3-23.6 526.4-14 689.7 120 729.7 120 872.6",
  stroke: "url(#bg-splash-left_svg__r)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-200.6 56.8c-72.8 262.5 156.2 280 171.1 469.3 12.5 157.7 140 201.5 140 346.4",
  stroke: "url(#bg-splash-left_svg__s)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-203 56.4C-272.8 319-53.9 341.2-35.4 525.8-20.1 677.9 101 725.6 101 872.5",
  stroke: "url(#bg-splash-left_svg__t)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-205.4 56.1c-66.9 262.5 141.9 289.6 164 469.4 18 146.5 132.8 198 132.8 347",
  stroke: "url(#bg-splash-left_svg__u)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-207.8 55.8C-271.6 318.3-73 350.2-47.3 525.3-26.5 666.2 81.9 721.5 81.9 872.5",
  stroke: "url(#bg-splash-left_svg__v)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-210.2 55.5C-271.1 317.9-82.7 354.7-53.2 525-29.8 660.3 72.4 719.5 72.4 872.5",
  stroke: "url(#bg-splash-left_svg__w)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-212.6 55.2c-57.9 262.4 120.3 304 153.5 469.6 26 129.7 122 192.7 122 347.8",
  stroke: "url(#bg-splash-left_svg__x)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-215 54.8c-54.9 262.4 112.9 308.8 150 469.6 28.5 124.2 118.3 191 118.3 348.1",
  stroke: "url(#bg-splash-left_svg__y)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-217.4 54.5C-269.3 316.9-111.9 368.1-71 524.2-39.9 642.8 43.8 713.3 43.8 872.5",
  stroke: "url(#bg-splash-left_svg__z)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-219.8 54.2c-48.9 262.3 98 318.5 142.9 469.7 33.6 113 111.1 187.4 111.1 348.6",
  stroke: "url(#bg-splash-left_svg__A)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-222.3 53.9c-45.8 262.3 90.5 323.4 139.5 469.7 36 107.5 107.5 185.6 107.5 348.9",
  stroke: "url(#bg-splash-left_svg__B)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-224.7 53.5c-42.8 262.3 82.8 328.4 135.9 469.9 38.4 102 103.9 183.8 103.9 349.1",
  stroke: "url(#bg-splash-left_svg__C)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-227.1 53.2c-39.9 262.2 75 333.4 132.4 469.9C-54.1 619.7 5.6 705.2 5.6 872.5",
  stroke: "url(#bg-splash-left_svg__D)"
}));

const SvgBgSplashLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 1446 813"
}, props), _ref, _ref2);

export default SvgBgSplashLeft;